export enum EBarTypes {
  BAR = `bar`,
  COUNTDOWN_BAR = `countdownBar`,
  INFO_BAR = `infoBar`,
}
